import { config } from "../../config/config";
import { Observable } from "rxjs";
import { utilService } from "../utils";

/**
 * Api services for key learning area component
 */
export const keyLearningAreaService = {
  getKeyLearningAreas,
  getKeyLearningAreasById,
};

function getKeyLearningAreas(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.key_learning_area + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function getKeyLearningAreasById(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.key_learning_area + data.id, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
